import { Label } from "../../common/GeneralClasses";
import { CommunicationsHubLabels } from "../../labels/CommunicationsHubLabels";
import { LabelsMapper } from "./LabelsMapper";

export class CommunicationsHubLabelsMapper extends LabelsMapper<CommunicationsHubLabels> {
  get(labels: Label[]): CommunicationsHubLabels {
    let resultMap = new Map();

    Object.entries(new CommunicationsHubLabels()).forEach((entry) => {
      resultMap.set(entry[0], this.getLabel(labels, entry[1].name));
    });
    return Object.fromEntries(resultMap);
  }

  replacePlaceholder(labels: Label[], value: string, placehodler: string): Label[] {
    return labels.map((label) => {
      if (label.value.includes(placehodler)) {
        label.value = label.value.replace(placehodler, value);
      }
      return label;
    });
  }
}
